var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessenger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 20.99999 22.00001",
    width: 20.99999,
    height: 22.00001,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0.000009999999999621423) rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "rgb(168, 168, 168)"
    },
    d: "M10.5,0c-5.77607,0 -10.5,4.52562 -10.5,10.13798c0,3.06865 1.4302,5.79287 3.65217,7.64769v4.21433l0.67052,-0.36839l3.29551,-1.76825c0.92018,0.25419 1.8778,0.41259 2.88179,0.41259c5.77607,0 10.5,-4.52562 10.5,-10.13798c0,-5.61236 -4.72393,-10.13798 -10.5,-10.13798zM10.5,0.94307c5.31598,0 9.58695,4.12961 9.58695,9.19491c0,5.06531 -4.27097,9.19491 -9.58695,9.19491c-0.98794,0 -1.94378,-0.14735 -2.83899,-0.41259l-0.1712,-0.04421l-0.15693,0.08841l-2.76766,1.48828v-3.09444l-0.1712,-0.13262c-2.12924,-1.69273 -3.48098,-4.24012 -3.48098,-7.08774c0,-5.0653 4.27097,-9.19491 9.58695,-9.19491zM9.45856,7.41192l-5.49252,6.01206l4.93614,-2.85867l2.63927,2.91762l5.42119,-6.071l-4.80774,2.785z",
    vectorEffect: "non-scaling-stroke"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1625214562718107",
    d: "M10.5,0c-5.77607,0 -10.5,4.52562 -10.5,10.13798c0,3.06865 1.4302,5.79287 3.65217,7.64769v4.21433l0.67052,-0.36839l3.29551,-1.76825c0.92018,0.25419 1.8778,0.41259 2.88179,0.41259c5.77607,0 10.5,-4.52562 10.5,-10.13798c0,-5.61236 -4.72393,-10.13798 -10.5,-10.13798zM10.5,0.94307c5.31598,0 9.58695,4.12961 9.58695,9.19491c0,5.06531 -4.27097,9.19491 -9.58695,9.19491c-0.98794,0 -1.94378,-0.14735 -2.83899,-0.41259l-0.1712,-0.04421l-0.15693,0.08841l-2.76766,1.48828v-3.09444l-0.1712,-0.13262c-2.12924,-1.69273 -3.48098,-4.24012 -3.48098,-7.08774c0,-5.0653 4.27097,-9.19491 9.58695,-9.19491zM9.45856,7.41192l-5.49252,6.01206l4.93614,-2.85867l2.63927,2.91762l5.42119,-6.071l-4.80774,2.785z",
    vectorEffect: "non-scaling-stroke"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.b024474a.svg";
export { ForwardRef as ReactComponent };